module.exports = __webpack_public_path__ + "static/media/cheese.96c5b3a4.svg";